define([
    'text!index2021-cooperate/component/enum-select.html',
    'cooperate/api'
], function(
    tpl,
    Api
){
    return {
        template: tpl,
        props: {
            value: {
                type: String
            },
            enumName: {
                type: String
            },
            defaultOption: {
                type: Object
            },
            fieldName: {
                type: String
            }
        },
        data: function(){
            return {
                options: []
            };
        },
        methods: {
            fetchOptions: function(){
                if (this.defaultOption){
                    this.options.push(this.defaultOption);
                }
                if (!this.enumName) return;
                var _this = this;
                Api.getCommonEnumApi.ajax({enumName: this.enumName})
                    .done(function(data){
                        _this.options = _this.options.concat(data);
                    });
            },
            onChange: function(event){
                this.$emit('input', event.target.value);
            }
        },
        created: function(){
            this.fetchOptions();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./index2021-cooperate/component/enum-select.js
// module id = 231
// module chunks = 0